import { isNonReplicatedField } from "../../db/nonReplicatedColumns";
import {
  type ConnectorFieldSource,
  getTargetValue,
  isItemVisible,
} from "./getTargetValue";
import { connectorDefinitions } from "./index";
import { listRows } from "./listRows";

export function isConfigured(
  app: ConnectorFieldSource & { identifier: string }
): boolean {
  const definition = connectorDefinitions.find(
    (d) => d.identifier === app.identifier
  );
  if (!definition) return true;

  const items = definition.steps
    .flatMap((step) => step.items)
    .filter((i) => isItemVisible(i, app, definition));
  const inputs = items.filter(
    (i) =>
      i.kind === "input" ||
      i.kind === "url" ||
      i.kind === "hostname" ||
      i.kind === "select"
  );
  const requiredInputs = inputs.filter((i) => i.required);

  if (
    requiredInputs.some(
      (i) => !isNonReplicatedField(i.target) && !getTargetValue(i.target, app)
    )
  ) {
    return false;
  }

  const requiredListEmpty = items.some(
    (i) =>
      i.kind === "list" &&
      i.required &&
      listRows(app.configuration, i.prefix).length === 0
  );
  if (requiredListEmpty) return false;

  const oauth = items.filter((i) => i.kind === "oauth");
  if (oauth.length > 0 && app.oauthConnection?.status === "not_connected") {
    return false;
  }

  return true;
}

export function isDraft(
  app: ConnectorFieldSource & { identifier: string }
): boolean {
  if (app.fresh) return true;
  return !isConfigured(app);
}
